import { BCMSRecord, useBCMSContext } from "@bcm-dev/bcms-vite";
import EDEStatementsPage from "components/EDEStatements/pages/EDEStatementsPage";
import Classes from "model";
import { useEffect } from "react";
import Util from "classes/Util";

/**
 * @name CaptureMabiEDEStatementsEnrollmentMyStatementsDefault
 * @returns {React.Component}
 * @description A capture in the MABI23 "Statement Preferences (EDE)" capture group.
 */
export default function CaptureMabiEDEStatementsEnrollmentMyStatementsDefault(props) {
    const context = useBCMSContext();
    BCMSRecord.globalControllerFor(Classes, context);
    const { branding } = context.state;

    useEffect(() => {
        Util.replaceDOMDataPointValues(branding);
    }); 

    return <EDEStatementsPage />;
}